<script>
    export let title = "";
    document.body.classList = 'vertical-layout vertical-menu-modern boxicon-layout no-card-shadow 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page';
</script>

<svelte:head>
    <title> { title || '-' } </title>
</svelte:head>

<slot></slot>
